import type { UserRegionalIdentity } from '../user.interface'

/**
 * Picks the regional identity for the current region, falling back to the first identity.
 */
export function resolveRegionalIdentityForRegion(
  identities: UserRegionalIdentity[],
  region: string
): UserRegionalIdentity | null {
  if (identities.length === 0) {
    return null
  }

  return identities.find((identity) => identity.region === region) ?? identities[0] ?? null
}
